import { render, staticRenderFns } from "./CropOtherFarms.vue?vue&type=template&id=14d7878d&"
import script from "./CropOtherFarms.vue?vue&type=script&lang=js&"
export * from "./CropOtherFarms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports